import { Directive, Provider } from '@angular/core';
import { AppContextDirective } from '@modules/common/directives/app-context.directive';
import { BaseAppStateService } from '@modules/common/services/base-app-state.service';
import { DeclineOnTrashModalService } from '../services/decline-on-trash-modal.service';
import { DefaultCalendarService } from '../services/default-calendar.service';
import { RecurrenceEditModalService } from '../services/recurrence-edit-modal.service';
import { CalendarAppStateService } from '../services/state.service';

@Directive({
  selector: '[appCalendarAppContext]',
  standalone: true,
})
export class CalendarAppContextDirective extends AppContextDirective {
  static readonly providers = [
    ...BaseAppStateService.provideAs(CalendarAppStateService),
    DefaultCalendarService,
    RecurrenceEditModalService,
    DeclineOnTrashModalService,
  ];

  protected getProviders(): Provider[] {
    return CalendarAppContextDirective.providers;
  }
}
